/** Convert a Figma hex scale into Chakra `tokens.colors` entries. */
export function colorScale<const T extends Record<string | number, string>>(scale: T) {
  return Object.fromEntries(Object.entries(scale).map(([step, hex]) => [step, { value: hex }])) as {
    [K in keyof T]: { value: T[K] };
  };
}
